import { useCountdown } from './useCountdown';
import { PRICE } from '../data/landing';
import { salesProof } from '../data/salesProof';
import { formatARS } from '../utils/currency';

/** Precio vigente: el de lanzamiento mientras corre el contador; el posterior cuando termina. */
export function usePricing() {
  const countdown = useCountdown(salesProof.launchEndsAt);
  const switched = countdown.ended && salesProof.priceAfterLaunch > 0;

  return {
    countdown,
    price: switched ? formatARS(salesProof.priceAfterLaunch) : PRICE,
    regularPrice: !switched && salesProof.regularPrice > 0 ? formatARS(salesProof.regularPrice) : null,
    launchActive: countdown.configured && !countdown.ended,
  };
}
